import {GearIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

import {DiffCompactLinesPopover} from './components/DiffCompactLinesPopover'
import {DiffLinePresentationToggles} from './components/DiffLinePresentationToggles'
import {DiffViewPreferenceToggle} from './components/DiffViewPreferenceToggle'

export type DiffViewSettingsProps = {
  lineSpacingPreferenceAvailable?: boolean
  reloadOnSplitPreferenceChange?: boolean
  reloadOnWhitespaceChange?: boolean
}

export function DiffViewSettings({
  lineSpacingPreferenceAvailable = true,
  reloadOnSplitPreferenceChange = false,
  reloadOnWhitespaceChange = false,
}: DiffViewSettingsProps) {
  return (
    <>
      <ActionMenu>
        <ActionMenu.Anchor>
          <button className="Button Button--iconOnly Button--invisible" aria-label="Open diff view settings">
            <GearIcon />
          </button>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay>
          <ActionList>
            <DiffViewPreferenceToggle reloadOnChange={reloadOnSplitPreferenceChange} />
            <ActionList.Divider />
            <DiffLinePresentationToggles
              lineSpacingPreferenceAvailable={lineSpacingPreferenceAvailable}
              reloadOnChange={reloadOnWhitespaceChange}
            />
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
      <DiffCompactLinesPopover />
    </>
  )
}

try{ DiffViewSettings.displayName ||= 'DiffViewSettings' } catch {}